import { List } from "@mui/material";

import type { RootState } from "../store/state/rootReducer";

import { DrawerMenuItem } from "./NewDrawerMenuItem";

export interface INavBarItemsProps {
  itemsById: RootState["frame"]["nav"]["itemsById"];
  rootIds: RootState["frame"]["nav"]["rootIds"];
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  alwaysShowChildren?: boolean;
}

export function NavBarItems(props: INavBarItemsProps) {
  return (
    <List disablePadding>
      {Object.values(props.itemsById)
        .filter((n) => props.rootIds.includes(n.id))
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        .map((n, index) => (
          <DrawerMenuItem
            item={n}
            key={n.id}
            index={index}
            isExpanded={props.isExpanded}
            idMap={props.itemsById}
            setIsExpanded={props.setIsExpanded}
            alwaysShowChildren={props.alwaysShowChildren || false}
          />
        ))}
    </List>
  );
}
